import { useState } from "react";
import CommonFaqs from "../../../modules/hints/components/faqs/CommonFaqs";
import Config from "../config";

const Faqs = ({ lang }: { lang: string }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (lang === "de") {
    return (
      <div className="min-h-full text-foreground gap-12 flex flex-col text-base">
        <CommonFaqs
          lang={lang}
          openIndex={openIndex}
          toggle={toggle}
          email="support@kolula.com"
          phone={Config.contact.phone}
          openingHours="07.00 - 21.00 Uhr"
        />
      </div>
    );
  } else {
    return (
      <div className="min-h-full text-foreground gap-12 flex flex-col text-base">
        <CommonFaqs
          lang={lang}
          openIndex={openIndex}
          toggle={toggle}
          email="support@kolula.com"
          phone={Config.contact.phone}
          openingHours="08.00 AM - 08.00 PM"
        />
      </div>
    );
  }
};

export default Faqs;
